export default __webpack_public_path__ + "static/lsa-fonts-c9967375e8fa9cc77380d4e64af92417.jpg";